import type { PreferenceProfile } from './types'
import type { LearningStyleType } from '@/types'

/**
 * 将详细偏好画像映射为当前课程引擎使用的单一学习风格。
 * 该规则是全项目唯一映射入口，避免不同页面产生不同结果。
 */
export function getPreferredLearningStyle(
  preference: PreferenceProfile,
): LearningStyleType {
  const candidates: Array<{ style: LearningStyleType; score: number }> = [
    { style: 'imagination', score: preference.presentation.narrative },
    { style: 'visual', score: preference.presentation.visual },
    { style: 'expression', score: preference.presentation.verbal },
    { style: 'challenge', score: preference.presentation.taskBased },
  ]

  return candidates.reduce((best, current) => (
    current.score > best.score ? current : best
  )).style
}
